/* unplugin-vue-components disabled */import script from "./ProductScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductScroll.vue?vue&type=script&setup=true&lang=ts"

import "./ProductScroll.vue?vue&type=style&index=0&id=fd11e926&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd11e926"]])

export default __exports__